import React, { useMemo } from "react";
import styled from "styled-components";
import isolation from "assets/Isolation_Mode.svg";
import starShape from "assets/starshape.svg";
import { colors } from "utils";

export const IsolationLayout = ({ children }) => {

  const availableColors = [
    colors.blue500,
    colors.yellow,
    colors.nightlyWoods500
  ];

  const availableSvgs = [
    isolation,
    starShape
  ];

  const selectedColor = useMemo(() => {
    return availableColors[Math.floor(Math.random() * availableColors.length)];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const selectedSvg = useMemo(() => {
    return availableSvgs[Math.floor(Math.random() * availableSvgs.length)];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <MainContainer className="fullscreen" backgroundColor={selectedColor}>
      <svg style={{ position: "absolute", top: "24px", left: "24px", zIndex: 1000 }}
           width="197"
           height="60"
           viewBox="0 0 197 60"
           fill="none"
           xmlns="http://www.w3.org/2000/svg">
        <path id="OKO_Core_Logotype2"
              d="M162.641 42.9128C154.378 42.9128 147.672 37.1034 147.672 30.0002C147.672 22.8969 154.378 17.0875 162.641 17.0875C170.905 17.0875 177.611 22.8969 177.611 30.0002C177.611 37.1034 170.878 42.9128 162.641 42.9128ZM162.641 0.161133C143.897 0.161133 128.716 13.5227 128.716 30.0002C128.716 46.4776 143.923 59.8392 162.641 59.8392C181.386 59.8392 196.566 46.4776 196.566 30.0002C196.566 13.5227 181.386 0.161133 162.641 0.161133ZM34.5179 42.9128C26.2544 42.9128 19.5486 37.1034 19.5486 30.0002C19.5486 22.8969 26.2544 17.0875 34.5179 17.0875C42.7814 17.0875 49.4872 22.8969 49.4872 30.0002C49.4872 37.1034 42.755 42.9128 34.5179 42.9128ZM34.4915 0.161133C15.7733 0.161133 0.566406 13.5227 0.566406 30.0002C0.566406 46.4776 15.7733 59.8392 34.4915 59.8392C53.2097 59.8392 68.4166 46.4776 68.4166 30.0002C68.443 13.5227 53.2361 0.161133 34.4915 0.161133ZM111.212 30.0002L137.877 0.979726H114.169L91.6494 25.3791V1.00613H72.2447V59.0206H91.6494V34.6741L114.064 59.047H137.877L111.08 30.0002H111.212Z"
              fill={selectedColor === colors.nightlyWoods500 ? colors.milkGlass500 : colors.nightlyWoods500}
        />
      </svg>
      <IsolationContainer selectedSvg={selectedSvg}>
        <img src={selectedSvg} alt="background shape" className="isolation-svg" />
        {children}
      </IsolationContainer>
    </MainContainer>
  );
};

const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${props => props.backgroundColor};
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
`;

const IsolationContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 90%;
  max-height: ${props => props.selectedSvg === isolation ? "514px" : "700px"};
  height: auto;
  aspect-ratio: ${props => props.selectedSvg === isolation ? 670 / 514 : 1};

  .isolation-svg {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 1;
    object-fit: contain;
    right: ${props => props.selectedSvg === isolation ? "0" : "24px"};
  }
`;
